$(function () {
    const splides = document.querySelectorAll('.plt__section .splide')

    if (splides.length > 0) {
        const splide = new Splide('.plt__section .splide', {
            padding: { left: '10px', right: '50px' },
            perPage: 1,
            trimSpace: false,
            keyboard: true,
            paginationKeyboard: true,
            mediaQuery: 'min',
            breakpoints: {
                768: {
                    padding: { left: '10%', right: '10%' },
                    start: 0,
                    focus: 0,
                    perPage: 2,
                },
                1024: {
                    perPage: 3,
                },
            },
        })

        function EqualizeFooterHeights() {
            const slider = document.querySelector('.plt__section .splide')
            const footers = slider.querySelectorAll('.plt__footer')

            let max_h_cta = 0
            let max_h_txt = 0

            footers.forEach((footer) => {
                const cta = footer.querySelector('.plt__footer--cta')
                const txt = footer.querySelector('.plt__footer--txt')
                if (cta && txt) {
                    // cta.style.height = 'auto'
                    // txt.style.height = 'auto'
                }
            })

            footers.forEach((footer) => {
                const cta = footer.querySelector('.plt__footer--cta')
                const txt = footer.querySelector('.plt__footer--txt')
                if (cta && txt) {
                    max_h_cta = Math.max(max_h_cta, cta.offsetHeight)
                    max_h_txt = Math.max(max_h_txt, txt.offsetHeight)
                }
            })

            footers.forEach((footer) => {
                const cta = footer.querySelector('.plt__footer--cta')
                const txt = footer.querySelector('.plt__footer--txt')
                if (cta && txt) {
                    // cta.style.height = `${max_h_cta}px`
                    // txt.style.height = `${max_h_txt}px`
                }
            })
        }

        function WaitForImagesThenEqualize() {
            const images = document.querySelectorAll('.plt__section .splide img')
            let loaded = 0
            const total = images.length

            if (total === 0) {
                EqualizeFooterHeights()
                return
            }

            images.forEach((img) => {
                if (img.complete) {
                    loaded++
                } else {
                    img.addEventListener('load', () => {
                        loaded++
                        if (loaded === total) {
                            EqualizeFooterHeights()
                        }
                    })
                    img.addEventListener('error', () => {
                        loaded++
                        if (loaded === total) {
                            EqualizeFooterHeights()
                        }
                    })
                }
            })

            if (loaded === total) {
                EqualizeFooterHeights()
            }
        }

        splide.on('mounted', () => {
            WaitForImagesThenEqualize()
        })

        splide.on('mounted move', () => {
            const slides = splide.Components.Slides.get()
            const activeIndex = splide.index
            const totalSlides = slides.length

            slides.forEach((slide, index) => {
                const el = slide.slide
                const isActive = index === activeIndex

                el.setAttribute('tabindex', isActive ? '0' : '-1')
                el.setAttribute('aria-hidden', isActive ? 'false' : 'true')
                el.setAttribute('aria-label', `Slide ${index + 1} of ${totalSlides}`)
                el.removeAttribute('role')
                el.removeAttribute('aria-roledescription')
            })
        })

        splide.mount()
    }
})
